import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  border: solid 1px #e8e8e8;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: start;
`;

export const Button = styled.button<{ variant: "active" | "inactive" }>`
  padding: 4px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  background-color: ${({ variant }) =>
    variant === "active" ? "#E9E6FB" : "transparent"};
  color: ${({ variant }) => (variant === "active" ? "#2F2CEE" : "#1A1A1A")};
  transition: background-color 0.2s;

  ${({ variant }) =>
    variant === "inactive" &&
    css`
      &:hover {
        background-color: #f5f5f5;
      }
    `}

  &:disabled {
    cursor: initial;
    opacity: 0.2;
    &:hover {
      background-color: initial;
    }
  }
`;
